import { useTranslation } from "react-i18next";

import { MoneyText } from "@/components/MoneyText";
import type { Cart } from "@/lib/types";

/**
 * 小計 / 値引 / 内消費税 / 合計 — exactly the server's numbers (the tax from tax-service, rounded once
 * per receipt). The tablet never adds these up itself (T07-23 acceptance).
 */
export function TotalsBar({ cart }: { cart: Cart | undefined }) {
  const { t } = useTranslation();
  const totals = cart?.totals;
  const tax = cart?.tax;
  return (
    <dl
      aria-label={t("cart.total")}
      className="grid grid-cols-[1fr_auto] items-baseline gap-x-4 gap-y-1 border-t px-3 py-3"
    >
      <dt>{t("cart.subtotal")}</dt>
      <dd className="text-right">
        {totals ? <MoneyText amount={totals.subtotal} data-testid="subtotal" /> : "—"}
      </dd>
      {totals && totals.discountTotal > 0 ? (
        <>
          <dt className="text-pos-problem">{t("cart.discount_total")}</dt>
          <dd className="text-right text-pos-problem">
            <MoneyText amount={totals.discountTotal} negative data-testid="discount-total" />
          </dd>
        </>
      ) : null}
      <dt className="text-muted-foreground">{t("cart.tax_included")}</dt>
      <dd className="text-right text-muted-foreground">
        {tax?.status === "ok" && typeof tax.amount === "number" ? (
          <MoneyText amount={tax.amount} size="sm" data-testid="tax-included" />
        ) : tax?.status === "unavailable" ? (
          <span className="text-pos-problem">{t("blocker.tax_unavailable")}</span>
        ) : (
          "—"
        )}
      </dd>
      <dt className="text-xl font-semibold">{t("cart.total")}</dt>
      <dd className="text-right">
        {totals ? <MoneyText amount={totals.total} size="xl" data-testid="total" /> : "—"}
      </dd>
    </dl>
  );
}
